"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.compound = void 0;
const commonDate = __importStar(require("../date"));
const commonUtils = __importStar(require("../utils"));
const sortRates = (rates) => [...rates].sort((r1, r2) => r1.date.localeCompare(r2.date));
// Stopgap to fill rates for current calendar year
const SIFMA_HOLIDAYS = new Set([
    '2026-01-01',
    '2026-01-19',
    '2026-02-16',
    '2026-04-03',
    '2026-05-25',
    '2026-06-19',
    '2026-07-03',
    '2026-09-07',
    '2026-10-12',
    '2026-11-11',
    '2026-11-26',
    '2026-12-25',
]);
const forEachDate = (startDate, endDate, operation) => {
    let currentDate = startDate;
    // eslint-disable-next-line no-restricted-syntax
    while (currentDate < endDate) {
        operation(currentDate);
        currentDate = commonDate.addDays(currentDate, 1);
    }
};
const compound = (params) => {
    const publishedRates = sortRates(params.publishedRates);
    const lastPublishedRate = publishedRates[publishedRates.length - 1];
    const missingRangeStartDate = lastPublishedRate
        ? commonDate.addDays(lastPublishedRate.date, 1)
        : params.startDate;
    forEachDate(missingRangeStartDate, params.endDate, (date) => {
        const isWeekend = commonDate.isWeekend(commonDate.fullDateStrToDateTime(date));
        const isHoliday = SIFMA_HOLIDAYS.has(date);
        if (!isWeekend && !isHoliday) {
            publishedRates.push({ date, value: null });
        }
    });
    const lookbackRates = [];
    forEachDate(params.startDate, params.endDate, (date) => {
        // Find index of business day for rate
        const rateIndex = publishedRates.findIndex((r, idx) => {
            const next = publishedRates[idx + 1];
            if (!next) {
                return true;
            }
            return r.date <= date && next.date > date;
        });
        if (rateIndex === -1 || rateIndex < params.calculation.lookback) {
            // Rates are either not available
            lookbackRates.push({
                date,
                lookbackDate: null,
                value: null,
                dayCount: 1,
            });
        }
        else {
            const rate = publishedRates[rateIndex];
            const lookbackRate = publishedRates[rateIndex - params.calculation.lookback];
            if (rate.date === date || date === params.startDate) {
                // Add a new entry for:
                // a) Business day,
                // b) Not business day but first date in the period
                lookbackRates.push({
                    date,
                    lookbackDate: lookbackRate.date,
                    value: lookbackRate.value,
                    dayCount: 1,
                });
            }
            else {
                // not business day, only increase daycount
                lookbackRates[lookbackRates.length - 1].dayCount += 1;
            }
        }
    });
    // Expected date for rate calculation to be finalized is always known even if rate data is not available yet
    const publishedDate = lookbackRates[lookbackRates.length - 1].lookbackDate;
    const dayCount = commonDate.diffDays(params.endDate, params.startDate);
    // If some rates are not available in this period, return a null rate
    if (lookbackRates.some((rate) => rate.value === null)) {
        return {
            effectiveDate: params.startDate,
            publishedDate,
            rate: null,
            dayCount,
        };
    }
    const discount = typeof params.calculation.discount === 'number'
        ? params.calculation.discount
        : 1;
    // Compounding takes the cumulative product of (1+ rate * day count / basis)
    const compoundedRate = lookbackRates.reduce((acc, rate) => acc *
        (1 + (rate.value * discount * rate.dayCount) / params.calculation.basis), 1);
    // And then applies the annualization factor (basis / day count)
    const rate = ((compoundedRate - 1) * params.calculation.basis) / dayCount;
    const roundedRate = commonUtils.jsRound({ value: rate, precision: 7 }); // 5 decimal places in percentage display
    return {
        effectiveDate: params.startDate,
        publishedDate,
        rate: roundedRate,
        dayCount,
    };
};
exports.compound = compound;
//# sourceMappingURL=compound.js.map